import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="faq-heading">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">常见问题</p>
          <h2 id="faq-heading" className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            关于久久久，您可能想了解
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                aria-expanded={openIndex === index}
              >
                <h4 className="text-base font-medium text-foreground-950 pr-4">{faq.question}</h4>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}